module.exports = __webpack_public_path__ + "static/media/ser_oh_lin.e3b9e4fd.png";